// extracted by mini-css-extract-plugin
export default {"wrapper":"InputNameBlock_wrapper__d2V3S","formGroup":"InputNameBlock_formGroup__HRxqc"};